<template>
    <div class="user-twofa-form">

        <h3 class="text-center mb-4">Two-factor authentication</h3>

        <b-form @submit.stop.prevent="onSubmit">

            <b-form-group horizontal
                          label-cols="4"
                          label="6-digit code"
                          :invalid-feedback="invalidFeedback('code')">
                <b-form-input ref="code"
                              type="text"
                              v-model="$v.code.$model"
                              @blur="blur"
                              :state="state('code')"/>
            </b-form-group>

            <b-button class="float-right mt-3"
                      type="submit"
                      variant="primary"
                      :disabled="$v.code.$invalid">
                Verify Code
            </b-button>

            <b-button class="float-right mr-3 mt-3"
                      variant="secondary"
                      @click="goBack">
                Go Back
            </b-button>

        </b-form>

        <b-alert show variant="danger" class="mt-3"
                 v-if="errorMessage">
            {{ errorMessage }}
        </b-alert>

    </div>

</template>

<script>

import Vue from 'vue'
import { validationMixin } from 'vuelidate'
import { maxLength, minLength, numeric, required } from 'vuelidate/lib/validators'

export default Vue.extend({
    name: 'UserTwofaForm',
    mixins: [validationMixin],
    data () {
        return {
            code: '',
            errorMessage: '',
            currentUser: this.$store.state.currentUser,
        }
    },
    validations: {
        code: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(6),
            numeric
        }
    },
    methods: {
        state (fieldName) {
            const f = this.$v[fieldName]
            if (f) {
                return f.$dirty ? !f.$error : null
            } else {
                return null
            }
        },
        invalidFeedback (fieldName) {
            let fb = ''
            if (fieldName === 'code') {
                let code = this.$v.code.$model
                if (!code) {
                    fb = 'Code is required'
                } else if (code.length !== 6) {
                    fb = 'Code must be six digits'
                } else if (!/^\d+$/.test(code)) {
                    fb = 'Code must only contain digits'
                }
            }
            return fb
        },
        blur () {
            this.$v.code.$touch()
        },
        async onSubmit (evt) {
            this.blur()
            if (!this.$v.code.$error) {
                try {
                    // check for requested path - e.g. URL is ?requestedPath/equipment%2Flist
                    const requestedPath = this.$route.query['requestedPath']
                    const data = await this.$user.loginTwofa(this, this.code)
                    if (data) {
                        if (requestedPath) {
                            this.$router.push(decodeURIComponent(requestedPath))
                        } else {
                            if (this.$router.currentRoute.path !== '/') {
                                this.$router.replace('/')
                            }
                        }
                    } else {
                        this.errorMessage = 'Unknown login issue'
                    }
                } catch (e) {
                    if (e && e.body && e.body.message) {
                        this.errorMessage = e.body.message
                    } else {
                        this.errorMessage = 'Incorrect code entered'
                    }
                }
            }
        },
        goBack () {
            this.$router.go(-1)
        },
    },
    mounted () {
        Vue.nextTick(() => this.$refs.code.$el.focus())
    }
})
</script>

<style lang="scss">

.user-twofa-form {
    h3 {
        color: #fff;
    }
}

</style>
